<template>

    <FloatingPanel>

        <div class="canvas-blocks-custom-leftVideoRightColumn-BlockPanel">

            <div class="m-5">

                <div class="mb-1 text-gray-600 label2">Video.</div>
                <small class="block mb-3 text-gray-500 text-muted">GELIEVE NIET TE GEBRUIKEN. JE KAN NU EEN VIDEO UPLOADEN. Dit veld werkt nog wel. Vul hier het adres in van de video link</small>

                <input
                    ref="url"
                    type="text"
                    class="w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 border-solid rounded-md shadow-sm focus:border-blue-300 focus:outline-none focus:shadow-outline-blue form-control form-input sm:leading-5 sm:text-sm"
                    placeholder="https://www."
                    v-model="options.url"
                />

            </div>

            <CommonInputs
                :options="options"
            />

        </div>

    </FloatingPanel>

</template>

<script>

import AbstractPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel";
import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
    },

}

</script>

<style lang="scss" scoped>

.canvas-blocks-custom-leftVideoRightColumn-BlockPanel {

}

</style>
